module.exports = __webpack_public_path__ + "static/GilroyAlt-SemiBold-bbd29f3abe3a2110adfca322d71a6fd3.woff2";